const VITE_API_BASE_URL = window.VITE_API_BASE_URL || "http://localhost:8000";

const VITE_SENTRY_DSN = window.VITE_SENTRY_DSN || "";

const VITE_SENTRY_ENV = window.VITE_SENTRY_ENV || "development";

const VITE_SENTRY_RELEASE = window.VITE_SENTRY_RELEASE || undefined;

const VITE_SENTRY_TRACES_RATE = window.VITE_SENTRY_TRACES_RATE
  ? Number(window.VITE_SENTRY_TRACES_RATE)
  : 0.1;

const VITE_SENTRY_REPLAY_RATE = window.VITE_SENTRY_REPLAY_RATE
  ? Number(window.VITE_SENTRY_REPLAY_RATE)
  : 0.05;

export {
  VITE_API_BASE_URL,
  VITE_SENTRY_DSN,
  VITE_SENTRY_ENV,
  VITE_SENTRY_RELEASE,
  VITE_SENTRY_TRACES_RATE,
  VITE_SENTRY_REPLAY_RATE,
};

// Pick values injected at runtime (via ConfigMap) or fall back to local defaults
